import { Paper, Typography, Grid } from '@material-ui/core';

import ItineraryTable from './ItineraryTable';

const ItineraryView = ({ bookingsData }) => {
    const { bookingItems, bookingItemsCount, grandTotal, taxesAndFees } = bookingsData;
    return (
        <Grid container fullWidth>
            <Grid item xs={12}>
                <Typography
                    variant="h3"
                    style={{
                        fontSize: '28px',
                        fontWeight: 'bold',
                        borderBottom: '2px solid #333',
                        paddingBottom: '10px',
                        marginBottom: '20px',
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    Your Itinerary
                </Typography>
            </Grid>
            {!bookingsData || bookingsData.bookingItems.length === 0 ? (
                <Grid item xs={12}>
                    <Paper elevation={3} style={{ padding: '40px', textAlign: 'center' }}>
                        <Typography style={{ fontSize: '24px', color: '#666' }}>
                            You don't have any bookings yet
                        </Typography>
                    </Paper>
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <ItineraryTable
                        itemsToBook={bookingItems}
                        bookingItemsCount={bookingItemsCount}
                        grandTotal={grandTotal}
                        taxesAndFees={taxesAndFees}
                        showFeeAndActivity={false}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default ItineraryView;
